import {
  Coaching,
  Courts,
  Facilities,
  LoginPage,
  OfficeAdminDashboard,
  OtpVerification,
  PosAdminDashboard,
  ResetPassword,
  Sports,
  SuperAdminDashboard,
  Users,
  AddUsers,
  ForgotPassword,
  UserInfo,
  UpdateUsers,
  UpdateSports,
  SportInfo,
  AddSports,
  AddFacilities,
  UpdateFacilities,
  FacilitiesInfo,
  AddCourt,
  UpdateCourt,
  CourtInfo,
  Profile,
  ListOfCourtsBooking,
  AddCourtBooking,
  CourtsBookingSummary,
  ListOfCoachingSessionBooking,
  UpdateProfile,
  CourtBookingDetails,
  RescheduleCourtBooking,
  SellingStockList,
  AddSellingInventory,
  UpdateSellingInventory,
  SellingInventoryDetails,
  ServicesStockList,
  AddServicesInventory,
  UpdateServicesInventory,
  ServicesInventoryDetails,
  ListOfPromotioanlOffers,
  CreateUpdatePromotionalNotification,
  ListOfPromotioanlNotification,
  CreateUpdatePromotionOffers,
  SystemNotification,
  Settings,
  ExitBooking,
  ListOfAssociateBooking,
  AssociateBookingSummary,
  AssociateBookingReschedule,
  AssociateGenerateInvoice,
  AssociateCollectCash,
  CreateAssociateBooking,
  AssociateBookingDetails,
  CustomerDashboard,
  SignUp,
  CustomerCourtBooking,
  CustomerCourtBookingDetails,
  CustomerBookingList,
  CustomerBookingHistory,
  CustomerCoachingBooking,
  FacilityAvailabilityCheck,
  CustomerCourtBookingReschedule,
  Payments,
  VerifyDeleteAccount ,
  DeleteAccount
} from "../modules";
import { AddNewCoachingSession } from "../modules/booking/CoachingSessionBooking/AddNewCoachingSession";
import { CoachingBookingDetail } from "../modules/booking/CoachingSessionBooking/CoachingBookingDetail";
import { CreateSession } from "../modules/Coaching/CreateSession";
import { EditSession } from "../modules/Coaching/EditSession";
import { CustomerNotification } from "../modules/CustomerNotification";

const DefaultRoute = [
  {
    name: "login-page",
    path: "/",
    id: "login-page",
    element: <LoginPage />,
  },
  {
    name: "verification",
    path: "/verification",
    id: "verification-page",
    element: <OtpVerification />,
  },
  {
    name: "reset-password",
    path: "/reset-password",
    id: "reset-password",
    element: <ResetPassword />,
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    id: "forgot-password",
    element: <ForgotPassword />,
  },
  {
    name: "verify-delete-account",
    path: "/verify-delete-account",
    id: "verify-delete-account",
    element: <VerifyDeleteAccount />,
  },
  {
    name: "delete-account",
    path: "/delete-account",
    id: "delete-account",
    element: <DeleteAccount />,
  },
  {
    name: "sign-up",
    path: "/sign-up",
    id: "sign-up",
    element: <SignUp />,
  },
  {
    name: "payments",
    path: "/payments",
    id: "payments",
    element: <Payments />,
  },
];

const Common = [
  {
    name: "court-booking",
    path: "/court-booking",
    id: "court-booking",
    element: <ListOfCourtsBooking />,
  },
  {
    name: "add-court-booking",
    path: "/add-court-booking",
    id: "add-court-booking",
    element: <AddCourtBooking />,
  },
  {
    name: "court-booking-details",
    path: "/court-booking-details",
    id: "court-booking-details",
    element: <CourtBookingDetails />,
  },
  {
    name: "court-booking-summary",
    path: "/court-booking-summary",
    id: "court-booking-summary",
    element: <CourtsBookingSummary />,
  },
  {
    name: "reschedule-court-booking",
    path: "/reschedule-court-booking",
    id: "reschedule-court-booking",
    element: <RescheduleCourtBooking />,
  },
  {
    name: "coaching-session-booking",
    path: "/coaching-session-booking",
    id: "coaching-session-booking",
    element: <ListOfCoachingSessionBooking />,
  },
  {
    name: "add-new-coaching-session-booking",
    path: "/coaching-session-booking/add-new",
    id: "coaching-session-booking",
    element: <AddNewCoachingSession />,
  },

  {
    name: "coaching-session-booking-detail",
    path: "/coaching-session-booking-detail/:id",
    id: "coaching-session-booking",
    element: <CoachingBookingDetail />,
  },
  {
    name: "exit-booking",
    path: "/exit-booking",
    id: "exit-booking",
    element: <ExitBooking />,
  },
  {
    name: "facility-availability-check",
    path: "/facility-availability-check",
    id: "facility-availability-check",
    element: <FacilityAvailabilityCheck />,
  },
  {
    name: "profile",
    path: "/profile",
    id: "profile",
    element: <Profile />,
  },
  {
    name: "verification",
    path: "/verification",
    id: "verification-page",
    element: <OtpVerification />,
  },
  {
    name: "payments",
    path: "/payments",
    id: "payments",
    element: <Payments />,
  },
];

const SuperAdminRoute = [
  ...Common,
  {
    name: "super-admin-dashboard",
    path: "/super-admin-dashboard",
    id: "super-admin-dashboard",
    element: <SuperAdminDashboard />,
  },
  {
    name: "coaching",
    path: "/coaching",
    id: "coaching",
    element: <Coaching />,
  },
  {
    name: "create-session",
    path: "/create-session",
    id: "create-session",
    element: <CreateSession />,
  },
  {
    name: "session-detail",
    path: "/session-detail/:id",
    id: "session-detail",
    element: <EditSession />,
  },
  {
    name: "update-session",
    path: "/update-session/:id",
    id: "update-session",
    element: <EditSession />,
  },
  {
    name: "users",
    path: "/users",
    id: "users",
    element: <Users />,
  },
  {
    name: "add-user",
    path: "/add-user",
    id: "add-user",
    element: <AddUsers />,
  },
  {
    name: "update-user",
    path: "/update-user",
    id: "update-user",
    element: <UpdateUsers />,
  },
  {
    name: "user-info",
    path: "/user-info",
    id: "user-info",
    element: <UserInfo />,
  },
  {
    name: "sports",
    path: "/sports",
    id: "sports",
    element: <Sports />,
  },
  {
    name: "add-sport",
    path: "/add-sport",
    id: "add-sport",
    element: <AddSports />,
  },
  {
    name: "update-sport",
    path: "/update-sport",
    id: "update-sport",
    element: <UpdateSports />,
  },
  {
    name: "sport-info",
    path: "/sport-info",
    id: "sport-info",
    element: <SportInfo />,
  },
  {
    name: "facilities",
    path: "/facilities",
    id: "facilities",
    element: <Facilities />,
  },
  {
    name: "add-facility",
    path: "/add-facility",
    id: "add-facility",
    element: <AddFacilities />,
  },
  {
    name: "update-facility",
    path: "/update-facility",
    id: "update-facility",
    element: <UpdateFacilities />,
  },
  {
    name: "facility-info",
    path: "/facility-info",
    id: "facility-info",
    element: <FacilitiesInfo />,
  },
  {
    name: "courts",
    path: "/courts",
    id: "courts",
    element: <Courts />,
  },
  {
    name: "add-court",
    path: "/add-court",
    id: "add-court",
    element: <AddCourt />,
  },
  {
    name: "update-court",
    path: "/update-court",
    id: "update-court",
    element: <UpdateCourt />,
  },
  {
    name: "court-info",
    path: "/court-info",
    id: "court-info",
    element: <CourtInfo />,
  },
  {
    name: "update-profile",
    path: "/update-profile",
    id: "update-profile",
    element: <UpdateProfile />,
  },
  {
    name: "sell-stock",
    path: "/sell-stock",
    id: "sell-stock",
    element: <SellingStockList />,
  },
  {
    name: "add-sell-stock",
    path: "/add-sell-stock",
    id: "add-sell-stock",
    element: <AddSellingInventory />,
  },
  {
    name: "update-sell-stock",
    path: "/update-sell-stock",
    id: "update-sell-stock",
    element: <UpdateSellingInventory />,
  },
  {
    name: "sell-stock-info",
    path: "/sell-stock-info",
    id: "sell-stock-info",
    element: <SellingInventoryDetails />,
  },
  {
    name: "rent-stock",
    path: "/rent-stock",
    id: "rent-stock",
    element: <ServicesStockList />,
  },
  {
    name: "add-rent-stock",
    path: "/add-rent-stock",
    id: "add-rent-stock",
    element: <AddServicesInventory />,
  },
  {
    name: "update-rent-stock",
    path: "/update-rent-stock/:id",
    id: "update-rent-stock",
    element: <UpdateServicesInventory />,
  },
  {
    name: "rent-stock-info",
    path: "/rent-stock-info/:id",
    id: "rent-stock-info",
    element: <ServicesInventoryDetails />,
  },
  {
    name: "promotional-notification",
    path: "/promotional-notification",
    id: "promotional-notification",
    element: <ListOfPromotioanlNotification />,
  },
  {
    name: "system-notification",
    path: "/system-notification",
    id: "system-notification",
    element: <SystemNotification />,
  },
  {
    name: "add-promotional-notification",
    path: "/add-promotional-notification",
    id: "add-promotional-notification",
    element: <CreateUpdatePromotionalNotification />,
  },
  {
    name: "update-promotional-notification",
    path: "/promotional-notification/:id",
    id: "update-promotional-notification",
    element: <CreateUpdatePromotionalNotification />,
  },
  {
    name: "discount-offers",
    path: "/discount-offers",
    id: "discount-offers",
    element: <ListOfPromotioanlOffers />,
  },
  {
    name: "create-update-discount-offer",
    path: "/create-update-discount-offer",
    id: "create-update-discount-offer",
    element: <CreateUpdatePromotionOffers />,
  },
  {
    name: "power-play-setting",
    path: "/power-play-setting",
    id: "power-play-setting",
    element: <Settings />,
  },
  {
    name: "associate-booking",
    path: "/associate-booking",
    id: "associate-booking",
    element: <ListOfAssociateBooking />,
  },
  {
    name: "create-associate-booking",
    path: "/create-associate-booking",
    id: "create-associate-booking",
    element: <CreateAssociateBooking />,
  },
  {
    name: "associate-booking-summary",
    path: "/associate-booking-summary",
    id: "associate-booking-summary",
    element: <AssociateBookingSummary />,
  },
  {
    name: "associate-booking-details",
    path: "/associate-booking-details",
    id: "associate-booking-details",
    element: <AssociateBookingDetails />,
  },
  {
    name: "reschedule-associate-booking",
    path: "/reschedule-associate-booking",
    id: "reschedule-associate-booking",
    element: <AssociateBookingReschedule />,
  },
  {
    name: "associate-generate-invoice",
    path: "/associate-generate-invoice",
    id: "associate-generate-invoice",
    element: <AssociateGenerateInvoice />,
  },
  {
    name: "associate-collect-cash",
    path: "/associate-collect-cash",
    id: "associate-collect-cash",
    element: <AssociateCollectCash />,
  },
];

const OfficeAdminRoute = [
  ...Common,
  {
    name: "office-admin-dashboard",
    path: "/office-admin-dashboard",
    id: "office-admin-dashboard",
    element: <OfficeAdminDashboard />,
  },
];

const PosAdminRoute = [
  {
    name: "verification",
    path: "/verification",
    id: "verification-page",
    element: <OtpVerification />,
  },
  {
    name: "pos-admin-dashboard",
    path: "/pos-admin-dashboard",
    id: "pos-admin-dashboard",
    element: <PosAdminDashboard />,
  },
  {
    name: "payments",
    path: "/payments",
    id: "payments",
    element: <Payments />,
  },
];

const CustomerRoute = [
  {
    name: "customer-dashboard",
    path: "/customer-dashboard",
    id: "customer-dashboard",
    element: <CustomerDashboard />,
  },
  {
    name: "customer-court-booking",
    path: "/customer-court-booking",
    id: "customer-court-booking",
    element: <CustomerCourtBooking />,
  },
  {
    name: "customer-court-booking-details",
    path: "/customer-court-booking-details",
    id: "customer-court-booking-details",
    element: <CustomerCourtBookingDetails />,
  },
  {
    name: "customer-court-booking-reschedule",
    path: "/customer-court-booking-reschedule",
    id: "customer-court-booking-reschedule",
    element: <CustomerCourtBookingReschedule />,
  },
  {
    name: "customer-booking-list",
    path: "/customer-booking-list",
    id: "customer-booking-list",
    element: <CustomerBookingList />,
  },
  {
    name: "customer-booking-history",
    path: "/customer-booking-history",
    id: "customer-booking-history",
    element: <CustomerBookingHistory />,
  },
  {
    name: "customer-coaching-booking",
    path: "/customer-coaching-booking",
    id: "customer-coaching-booking",
    element: <CustomerCoachingBooking />,
  },
  {
    name: "coaching-session-booking-detail",
    path: "/coaching-session-booking-detail/:id",
    id: "coaching-session-booking",
    element: <CoachingBookingDetail />,
  },
  {
    name: "profile",
    path: "/profile",
    id: "profile",
    element: <Profile />,
  },
  {
    name: "update-profile",
    path: "/update-profile",
    id: "update-profile",
    element: <UpdateProfile />,
  },
  {
    name: "notification",
    path: "/notification",
    id: "notification",
    element: <CustomerNotification />,
  },
  {
    name: "payments",
    path: "/payments",
    id: "payments",
    element: <Payments />,
  },
];

export {
  SuperAdminRoute,
  OfficeAdminRoute,
  PosAdminRoute,
  DefaultRoute,
  CustomerRoute,
};
